<template>
<div class="container main">
  <div class="row">
    <div class="offset-10 col-2 head-buttons-block">
      <router-link :to="{ name: 'auth'}" class="login-btn">
        <div class="enter-logo"></div><span>Войти</span>
      </router-link>
    </div>
    <div class="col-md-12">
      <div class="logo">
        <img src="/static/img/logo.png">
          </div>
      </div>
      <div class="col-md-12">
        <h2 class="recovery-head-text">
          Введите адрес электронной почты, указанный при регистрации.<br>
            Мы вышлем инструкции по восстановлению пароля.
          </h2>
          <div class="loader" v-if="loader">
            <loader-component />
          </div>
          <div class="offset-md-3 col-md-6" v-if="!view_form">
            <msg-component :type_msg="msg_email.type" :text="msg_email.text"></msg-component>
          </div>
          <div class="login_form" v-if="view_form">
              <div class="col-md-12">
                <input class="mail" v-bind:class="{fail: msg_email.error}" v-model="email"
                v-on:keyup.enter="recoveryPassword()"
                placeholder="Электронная почта" type="text" autocomplete="off">
                </div>
                <div class="offset-md-3 col-md-6 after-input-msg">
              <p v-if="msg_email.text">{{msg_email.text}}</p>
            </div>
            <div class="col-md-12">
              <button class="enter" @click="recoveryPassword">Восстановить пароль</button>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

export default {
  data() {
    return {
      msg_email: {
        type: 'hidden',
        text: '',
        error: false
      },
      email: '',
      view_form: true,
      loader: false
    }
  },
  components: {
    'msg-component': msg,
    'loader-component': loader
  },
  methods: {
    recoveryPassword: function () {
      var vue_obj = this
      vue_obj.view_form = false
      vue_obj.loader = true
      vue_obj.msg_email.type = 'hidden'
      vue_obj.msg_email.error = false
      vue_obj.msg_email.text = ''

      var post_data = new FormData()
      post_data.set('email', this.email)

      axios({
          method: 'POST',
          url: config.API_HOST + '/user/send-code-for-restore-password',
          data: post_data
        })
        .then(function (response) {
          vue_obj.loader = false
          if (!!response.data.text) {
            vue_obj.msg_email.type = 'success'
            vue_obj.msg_email.text = response.data.text
          }
        })
        .catch(function (error) {
          console.log(error.response.data)
          vue_obj.loader = false
          vue_obj.view_form = true
          if (!!error.response.data.exception) {
            vue_obj.msg_email.type = 'alert'
            vue_obj.msg_email.text = error.response.data.exception
            vue_obj.msg_email.error = true
          }
        })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/recovery_password.vue